var map = {
	"./bender.png": 4328,
	"./circle_square.png": 8620,
	"./circles.png": 7749,
	"./getintouch.png": 2198,
	"./identitaDigitale.png": 9787,
	"./mobile/bender.png": 6887,
	"./mobile/circle_square.png": 9809,
	"./mobile/circles.png": 4344,
	"./mobile/getintouch.png": 8393,
	"./mobile/identitaDigitale.png": 2384,
	"./mobile/motoreInteresse.png": 7421,
	"./mobile/notarizeMe.png": 3541,
	"./mobile/opener.png": 5210,
	"./mobile/phone-fifth.png": 6423,
	"./mobile/phone-first.png": 4674,
	"./mobile/phone-fouth.png": 5318,
	"./mobile/phone-second.png": 3798,
	"./mobile/phone-third.png": 8107,
	"./mobile/squares.png": 5275,
	"./motoreInteresse.png": 7616,
	"./notarizeMe.png": 8086,
	"./opener.png": 9881,
	"./phone-fifth.png": 5910,
	"./phone-first.png": 4211,
	"./phone-fouth.png": 1379,
	"./phone-second.png": 6889,
	"./phone-third.png": 3458,
	"./squares.png": 2466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;